/* Shared formatters for the redesigned screens. Kept in one place so dates and
   money read identically on every screen.

   Every timestamp is rendered in IST, not the viewer's zone. Staarvani runs on IST
   -- see helpers/dates.js, which already scopes "today" to the IST calendar day --
   so a timestamp shown to an admin abroad has to mean the same instant-in-IST as it
   does to one in Mumbai, or the two of them read different times off the same row. */
const IST = 'Asia/Kolkata';

export function formatDate(value) {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    timeZone: IST,
  });
}

export function formatDateTime(value) {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: IST,
  });
}

export function formatTime(value) {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', timeZone: IST });
}

export function inr(value) {
  if (value == null) return '—';
  return `₹${Number(value).toLocaleString('en-IN', { maximumFractionDigits: 0 })}`;
}

export function number(value) {
  if (value == null) return '—';
  return Number(value).toLocaleString('en-IN');
}

/** `{country_code, number}` -> "+91 98450 21774" */
export function phone(value) {
  if (!value?.number) return '—';
  return `${value.country_code || ''} ${value.number}`.trim();
}
